<template>
  <router-view/>
</template>

<style>

:root{
    --background: #fafafa;
    --card: #ffffff;
    --foreground: #09090b;
    --muted: #f4f4f5;
    --muted-foreground: #71717a;
    --border: #e4e4e7;
    --border-hover: #d4d4d8;
    --input-border-focus: #a1a1aa;
    --placeholder: #a1a1aa;
    --primary: #18181b;
    --primary-hover: #27272a;
    --primary-foreground: #fafafa;
    --ring: rgba(24, 24, 27, 0.12);
    --destructive: #dc2626;
    --destructive-hover: #b91c1c;
    --destructive-soft: #fef2f2;
    --radius: 10px;
    --shadow-sm: 0 1px 2px rgba(0, 0, 0, 0.05);
    --header-bg: rgba(255, 255, 255, 0.85);
}

html.dark{
    --background: #09090b;
    --card: #101012;
    --foreground: #fafafa;
    --muted: #1c1c1f;
    --muted-foreground: #a1a1aa;
    --border: #27272a;
    --border-hover: #3f3f46;
    --input-border-focus: #71717a;
    --placeholder: #71717a;
    --primary: #fafafa;
    --primary-hover: #e4e4e7;
    --primary-foreground: #18181b;
    --ring: rgba(250, 250, 250, 0.14);
    --destructive: #ef4444;
    --destructive-hover: #dc2626;
    --destructive-soft: rgba(239, 68, 68, 0.12);
    --shadow-sm: 0 1px 2px rgba(0, 0, 0, 0.4);
    --header-bg: rgba(9, 9, 11, 0.8);
}

*{
    padding: 0;
    margin: 0;
    box-sizing: border-box;
}

html{
    color-scheme: light;
}

html.dark{
    color-scheme: dark;
}

html,
body{
    height: 100%;
}

body{
    font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif;
    font-size: 15px;
    background: var(--background);
    color: var(--foreground);
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
}

#app{
    min-height: 100vh;
}

/* --- Общие каркасы страниц и карточек --- */

.page-main{
    padding: 40px 0 64px;
}

.page-container{
    width: 85%;
    max-width: 1100px;
    margin: 0 auto;
}

.page-header{
    display: flex;
    align-items: flex-end;
    justify-content: space-between;
    gap: 16px;
    margin-bottom: 24px;
}

.page-title{
    font-size: 24px;
    font-weight: 600;
    letter-spacing: -0.02em;
}

.page-description{
    margin-top: 6px;
    color: var(--muted-foreground);
    font-size: 14px;
}

.card{
    background: var(--card);
    border: 1px solid var(--border);
    border-radius: var(--radius);
    box-shadow: var(--shadow-sm);
    margin-bottom: 20px;
    overflow: hidden;
}

.card-header{
    padding: 16px 20px;
    border-bottom: 1px solid var(--border);
}

.card-title{
    display: flex;
    align-items: center;
    gap: 8px;

    font-size: 15px;
    font-weight: 600;
}

.card-title-icon{
    width: 16px;
    height: 16px;

    color: var(--muted-foreground);
}

.card-body{
    padding: 20px;
}

.card-footer{
    padding: 14px 20px;
    border-top: 1px solid var(--border);
    background: var(--muted);
}

.grid-2{
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(240px, 1fr));
    gap: 16px;
}

.empty{
    padding: 28px 20px;
    text-align: center;
    color: var(--muted-foreground);
    font-size: 14px;
    border: 1px dashed var(--border);
    border-radius: var(--radius);
}

</style>

